<template>
  <div class="capillary-rise-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>h = 2γ cosθ / (ρgr) | 尤林定律$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Liquid Tank -->
          <rect x="50" y="180" width="300" height="40" fill="rgba(34, 166, 179, 0.4)" stroke="#22a6b3" />
          
          <!-- Capillary Tubes of different radii -->
          <g v-for="i in 3" :key="i" :transform="`translate(${100 + i*60}, 40)`">
             <rect :width="40/i" height="150" fill="rgba(255,255,255,0.05)" stroke="#888" />
             <!-- Liquid inside tube -->
             <rect :width="40/i - 2" :height="getRise(i)" :y="140 - getRise(i)" x="1" fill="#22a6b3" opacity="0.6" />
             <!-- Meniscus (Simplified curve at top) -->
             <path :d="getMeniscus(i)" fill="#22a6b3" opacity="0.6" :transform="`translate(0, ${140 - getRise(i)})`"/>
             
             <text x="0" y="170" fill="#888" font-size="8">半径: {{ (1/i).toFixed(1) }}r</text>
          </g>

          <line x1="50" y1="180" x2="350" y2="180" stroke="#22a6b3" stroke-width="1" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>介质: 水-玻璃 (接触角 θ ~ 0°)</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>表面张力系数 γ</label>
             <el-slider v-model="tension" :min="10" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>毛细现象是指液体在细微管状物体内，由于附着力与内聚力的合力作用，克服重力而上升（或下降）的现象。根据**尤林定律**，液体上升的高度与管子半径成成反比：管子越细，上升越高。这就是植物根系能够将水分输送到高耸树顶的重要原因之一，也是纸巾吸水、浸润现象的微观基础。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CapillaryRiseViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      tension: 50
    }
  },
  methods: {
    getRise(i) {
       // h is proportional to tension / radius. radius is 40/i.
       // So h is proportional to tension * i.
       return (this.tension * 0.5) * i;
    },
    getMeniscus(i) {
       let w = 40/i - 2;
       return `M 1,0 Q ${1 + w/2},5 ${1 + w},0 L ${1 + w},0 L 1,0 Z`;
    }
  }
}
</script>

<style scoped lang="scss">
.capillary-rise-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(34, 166, 179, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
